import React from "react";
import { easeInOut, motion } from "framer-motion";
import aboutUsImage from "../../../../assets/images/about-us-image.avif";
import { useLanguage } from "../../../../contexts/LanguageContext";
import { aboutUs } from "../../../../utils/translations";
import useIsMobilei from "../../../../hooks/isMobile"; 
import "./aboutUs.css";

export default function AboutUs() {
  const { language } = useLanguage();
  const { isMobilei } = useIsMobilei(); 

  const initialAnimation = isMobilei 
      ? { opacity: 0, x: -100 }
      : { opacity: 0, x: -500 } 

  return (
      <motion.div 
      className= {`aboutUs-container ${language === "ar" ? "arab" : ""} ${language === "ar" ? "rtl" : ""}`}
      initial={initialAnimation}
      whileInView={{opacity : 1 , x : 0}}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.8 , ease: easeInOut  }} 
      >

        <div className="aboutUs-textContainer">
          <h2 className= {`aboutUs-title ${language === "ar" ? "aboutUs-arab" : ""}`}>{aboutUs[language].title}</h2>
          <h3 className= {`aboutUs-intro ${language === "ar" ? "aboutUs-arab" : ""}`}>{aboutUs[language].intro}</h3>
          <p className= {`aboutUs-pargraph1 ${language === "ar" ? "aboutUs-arab" : ""}`}>{aboutUs[language].paragraph1}</p>
          <p className= {`aboutUs-pargraph2 ${language === "ar" ? "aboutUs-arab" : ""}`}>{aboutUs[language].paragraph2}</p>
          <p>{aboutUs[language].paragraph3}</p>
          <p  className= {`aboutUs-closing ${language === "ar" ? "aboutUs-arab" : ""}`}>
            <b>{aboutUs[language].closing}</b>
          </p>
        </div>
        <div className="aboutUs-imageContainer">
          <img dir="ltr" src={aboutUsImage} alt="Gifts and joy" className="aboutUs-image" />
        </div>
    </motion.div>
  );
}